<template>
  <section class="site-banner background background-grey" :class="{ 'is-active': isActiveBanner }" data-cy="country-redirect-banner">
    <div class="section-container">
      <div class="section-layout">
        <div class="site-banner-container">
          <div class="site-banner-details">
            <p class="text-body m-0">{{ title }}</p>
            <slot />
          </div>
          <div class="ml-auto">
            <button :aria-label="closeLabel" class="button-round" @click="onClose">
              <Icon icon="close" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import Icon from '@/components/shared/IconBase.vue';
import { LocalStorage } from '@/utils/storage';

defineProps({
  title: {
    type: String,
    required: true,
  },
  closeLabel: {
    type: String,
    required: true,
  },
});

const COUNTRY_REDIRECT_SHOWN = 'country_redirect_shown';

const hasClosedBanner = ref(LocalStorage.get(COUNTRY_REDIRECT_SHOWN) || false);
const hasMadeCookiesChoice = ref(false);
const isActiveBanner = computed(() => !hasClosedBanner.value && hasMadeCookiesChoice.value);

onMounted(() => {
  updateCookieConsentStatus();
  window.addEventListener('CookiebotOnConsentReady', updateCookieConsentStatus, false);
});

function updateCookieConsentStatus() {
  if (window.Cookiebot) {
    hasMadeCookiesChoice.value = window.Cookiebot.hasResponse;
  }
}

function onClose() {
  hasClosedBanner.value = true;
  LocalStorage.set(COUNTRY_REDIRECT_SHOWN, true);
}
</script>
